import React from "react";
import { useIsMobile } from "@/hooks/useDisplay";
import { usePermission } from "@/features/auth/hooks/usePermission";
import { PickSlipUnauthorizedAlerts } from "@/features/pickems/components/pick-slip/PickSlipUnauthorizedAlerts";
import { ScrollArea } from "@picklebet/ui";
import {
  Tab,
  Tabs,
  TabsList,
} from "@/features/shell/components/shared/Tabs/Tabs";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { PageMessage } from "@picklebet/ui";
import { Button } from "@picklebet/ui";
import { navigate } from "@/utilities/navigate";
import { triggerHaptic } from "@/utilities/haptics";

import { ChevronDownIcon } from "@picklebet/ui";
import { ReactComponent as EmptyIllustration } from "assets/illustrations/empty-pickems.svg";

import * as styles from "./PickSlip.module.scss";

const PickSlipNoContest = () => {
  const closeDock = useShellStore((state) => state.closeDock);
  const permission = usePermission("submitPickems");
  const isMobile = useIsMobile();

  return (
    <div className={styles.container}>
      <Tabs value="pickems-lobby" className={styles.tabs}>
        <TabsList
          containerClassName={styles.tabListContainer}
          widget={
            <div onClick={closeDock} className={styles.close}>
              <ChevronDownIcon />
            </div>
          }
          className={styles.tabList}
        >
          <Tab value="pickems-lobby">Pick'ems</Tab>
        </TabsList>
        <ScrollArea className={styles.scrollArea} orientation="vertical">
          <div className={styles.content}>
            <PickSlipUnauthorizedAlerts key="unauthorizedPickemsAlerts" />
            <PageMessage
              className={styles.empty}
              title={"Your Pickslip is Empty"}
              subTitle={
                "Select a contest to submit, or swap your existing picks"
              }
              image={<EmptyIllustration />}
            >
              {isMobile && permission === "GRANTED" && (
                <Button
                  size={"md"}
                  onClick={() => {
                    closeDock();
                    navigate("/pickems");
                    triggerHaptic.click();
                  }}
                >
                  View Lobby
                </Button>
              )}
            </PageMessage>
          </div>
        </ScrollArea>
      </Tabs>
    </div>
  );
};

export { PickSlipNoContest };
